export enum EnumFlatFileType {
  文字檔下載 = 'GENERAL',
  貨號文字檔下載 = 'PRODUCT_CODE',
}
export default EnumFlatFileType;
